import { render } from "./FilePage.vue?vue&type=template&id=4d73b40a"
import script from "./FilePage.vue?vue&type=script&lang=js"
export * from "./FilePage.vue?vue&type=script&lang=js"
script.render = render

export default script